'use client';

import React from 'react';

import { ComponentContainer, ComponentWrapper } from '../shared/styles';

import { CalloutFeature } from './CalloutFeature';
import { Wrapper } from './styles';
import { BenefitsRowProps } from './types';

export const BenefitsRow = ({ calloutFeatures }: BenefitsRowProps) => {
  return (
    <ComponentWrapper>
      <ComponentContainer>
        <Wrapper>
          {calloutFeatures.map((item) => (
            <CalloutFeature
              key={item.id}
              description={item.description}
              icon={item.icon}
              text={item.text}
            />
          ))}
        </Wrapper>
      </ComponentContainer>
    </ComponentWrapper>
  );
};
